import { createContext, useContext } from 'react';
import { UserProcResponse } from '@/shared/api';

type ProcInstanceContextType = {
  procInstance?: UserProcResponse;
  selectedStepId?: string;
  handleStepSelect?: (id: string) => void;
};

export const ProcInstanceContext = createContext<ProcInstanceContextType>(
  {} as ProcInstanceContextType,
);

export const useProcInstanceContext = () => useContext(ProcInstanceContext);
